// One nesting level is enough: `@keyframes name { from {…} to {…} }`
const KEYFRAMES_RE = /@keyframes\s+[^{]+\{(?:[^{}]|\{[^{}]*\})*\}/g;

/**
 * `__CSS` is injected into a declaration block, so `@keyframes` there are invalid.
 * Pull them out so they can be emitted as top-level at-rules.
 */
export function extractKeyframes(css: string): { declarations: string; keyframes: string } {
	const keyframesParts: string[] = [];
	const declarations = css
		.replace(KEYFRAMES_RE, match => {
			keyframesParts.push(match.trim());
			return '';
		})
		.replace(/^[\s;]+|[\s;]+$/g, '');

	return { declarations, keyframes: keyframesParts.join('\n') };
}
